window.MachineFilter = function()
{
    let self = this;
    $select_type        = $('.js-select-type');
    $filter_results     = $('.js-filter-machines');
    $results_for_sale   = $('.js-for-sale-result');
    $results_sold       = $('.js-sold-result');
    $target_btn         = $('.js-btn-target');
    $model_dropdown     = $('.js-model-dropdown');
    $model_btn          = $('.js-model-btn');

    // checkboxes
    $brand_options          = $('.js-car-brand');
    $model_options          = $('.js-car-model');
    $machine_type_options   = $('.js-select-machine-type');


    /**
     * Initialize all event listeners
     *
     * @author Rick van der Burg <rick@pixcero.nl>
     * @return void
     */
    self.init = function(type)
    {
        $select_type.on('click', self.selectFilter);
        $brand_options.on('change', self.selectFilterByCheckbox);
        $model_options.on('change', self.selectFilterByCheckbox);
        $machine_type_options.on('change', self.selectFilterByCheckbox);
        $brand_options.on('change', self.showBelongingModels);
        if(type == 'equipment') {
            $($select_type.filter('[data-target="machinery"]')).trigger('click');
        }
    };

    /**
     * Show belonging models based on the brand
     *
     * @author Rick van der Burg <rick@pixcero.nl>
     * @return void
     */
    self.showBelongingModels = function()
    {
        // get all models based on brand
        axios.get('/!/filter/models?brand=' + $(this).val())
            .then((response) => {
                // hide model dropdown
                $model_dropdown.addClass('hide');
                // when the response have any results
                if(response.data.length > 0) {
                    // show model button
                    $model_btn.removeClass('hide');
                    // loop through all ids
                    for (let id in response.data) {
                        let model_id = response.data[id];
                        // Show all model options where the model id is the same as the filter
                        $model_dropdown.filter('[data-model-id='+ model_id +']').removeClass('hide');
                    }
                } else {
                    $model_btn.addClass('hide');
                    $model_options.addClass('hide');
                }
            });
    };

    /**
     * Select filter
     *
     * @author Rick van der Burg <rick@pixcero.nl>
     * @param e
     * @return void
     */
    self.selectFilter = function(e)
    {
        e.preventDefault();
        $select_type.removeClass('is-active');
        $(this).addClass('is-active');
        $filter_results.addClass('hide');
        let target = $(this).data('target');
        $filter_results.filter('[data-target='+target+']').removeClass('hide');
        self.resetFilter();
        self.loadData(target);
    };

    self.selectFilterByCheckbox = function(e)
    {
        if($(this).is('input')) {
            let trigger = $(this).data('button-trigger');
            var name    = $(this).data('name');
            let target_btn = $target_btn.filter('[data-button-target="'+ trigger +'"]');
            let placeholder = $(this).data('placeholder');
            // we need to do the opposite since the button is already checked when pressing it
            if(target_btn.text() === name) {
                target_btn.text(placeholder);
                target_btn.removeClass('selected');
            } else {
                target_btn.text(name);
                target_btn.addClass('selected');
            }

            // close filter dropdown
            $(this).parents('.js-dropdown-pane').foundation('close');
        }
        e.preventDefault();
        let target = $(this).data('target');
        self.loadData(target, name);
    };

    self.loadData = function(target, name)
    {
        let parameter_string = '';
        let brand_selected = false;
        if(target === 'car') {
            let brands = [];
            $brand_options.filter(':checked').each(function() {
                // only push the models to the array when the attribute of the current is equal to the loop :checked
                if($(this).data('name') === name) {
                    brand_selected = true;
                    brands.push($(this).val());
                }
            });
            if(brands.length > 0) {
                parameter_string += '&brand=' + brands.join(',');
            }

            let models = [];
            // when a brand is selected, dont execute model search
            if(brand_selected === false) {
                $model_options.filter(':checked').each(function() {
                    // only push the models to the array when the attribute of the current is equal to the loop :checked
                    if($(this).data('name') === name) {
                        models.push($(this).val());
                    }
                });
            } else {
                $model_options.removeAttr('checked');
                $target_btn.filter('[data-button-target="model"]').text('Choose a model');
            }
            if(models.length > 0) {
                parameter_string += '&model=' + models.join(',');
            }
        }

        if(target == 'machinery') {
            let types = [];
            $machine_type_options.filter(':checked').each(function() {
                if($(this).data('name') === name) {
                    types.push($(this).val());
                }
            });
            if(types.length > 0) {
                parameter_string += '&machine-type=' + types.join(',');
            }
        }


        axios.get('/!/filter/index?type=' + target + parameter_string)
            .then((response) => {
                $results_for_sale.html(response.data.for_sale_entries);
                $results_sold.html(response.data.sold_entries);
                new Foundation.Equalizer($results_for_sale);
            });
    };


    self.resetFilter = function()
    {
        $brand_options.prop('checked', false);
        $model_options.prop('checked', false);
        $machine_type_options.prop('checked', false);
    }
};



// WEBPACK FOOTER //
// ./scripts/components/filter.js